import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ActiveWorkersWoMandatoryPPEService, ActiveWorkersWoMandatoryPPEServiceData } from "../../services/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPE.service";
import { ActiveWorkersWoMandatoryPPEDetailService, ActiveWorkersWoMandatoryPPEDetailServiceData, WorkerDetail } from "../../services/occupationalRiskPreventionKpi/activeWorkersWoMandatoryPPEDetail.service";
import { ColumnDefinition, DateColumnDefinition, EmailColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class ActiveWorkersWoMandatoryPPEDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'active-workers-wo-mandatory-ppe-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class ActiveWorkersWoMandatoryPPEKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<ActiveWorkersWoMandatoryPPEService, ActiveWorkersWoMandatoryPPEServiceData, ActiveWorkersWoMandatoryPPEServiceData, ActiveWorkersWoMandatoryPPEDetailService, ActiveWorkersWoMandatoryPPEDetailServiceData, ActiveWorkersWoMandatoryPPEDetailData>
    implements OnDestroy {
    public getClassName() { return "ActiveWorkersWoMandatoryPPEKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: ActiveWorkersWoMandatoryPPEService, detailService: ActiveWorkersWoMandatoryPPEDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: ActiveWorkersWoMandatoryPPEServiceData): ActiveWorkersWoMandatoryPPEServiceData {
        return data;
    }

    protected getDefaultSummaryData(): ActiveWorkersWoMandatoryPPEServiceData {
        let data = new ActiveWorkersWoMandatoryPPEServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();

        return data;
    }

    protected extractUpdateTime(data: ActiveWorkersWoMandatoryPPEServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ActiveWorkersWoMandatoryPPEDetailServiceData, args: any): ActiveWorkersWoMandatoryPPEDetailData {
        if (data.workers) {
            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = [
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador", null, true),
                    new TextColumnDefinition("EPI"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new TextColumnDefinition("Consultor", null, true),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[6].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let worker of data.workers) {

                    data.workers.sort(function (a, b) {
                        if (a.contractFiscalName > b.contractFiscalName) {
                            return 1;
                        }
                        if (a.contractFiscalName < b.contractFiscalName) {
                            return -1;
                        }
                        return 0;
                    });

                    if (worker.nif.toUpperCase() == consultantNif) {

                        tabledata.push([
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.workerPPESetDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                            worker.name,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.workerPPESetDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                            worker.name,
                        ]);
                    }

                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ActiveWorkersWoMandatoryPPEDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = [
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador", null, true),
                    new TextColumnDefinition("EPI"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];

                data.workers = data.workers.sort(function (a, b) {
                    if (a.contractFiscalName > b.contractFiscalName) {
                        return 1;
                    }
                    if (a.contractFiscalName < b.contractFiscalName) {
                        return -1;
                    }
                    return 0;
                });

                for (let worker of data.workers) {
                    if (worker.nif.toUpperCase() == consultantNif) {

                        tabledata.push([
                            worker.name,
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.workerPPESetDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                        ]);
                    }
                    else {
                        tabledata2.push([
                            worker.name,
                            worker.contractFiscalName,
                            worker.workerName,
                            worker.workerPPESetDescription,
                            worker.workerPhone,
                            worker.workerEmail,
                            moment(worker.contractBeginDate).startOf("day"),
                        ]);
                    }

                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ActiveWorkersWoMandatoryPPEDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: WorkerDetail[]): { nif: string, name: string }[] {
        let nifs: { nif: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!nifs.find(y => x.nif.toUpperCase() == y.nif)) nifs.push({ nif: x.nif.toUpperCase(), name: x.name });
            })
        }

        return nifs;
    }

    protected getDefaultDetailData(): ActiveWorkersWoMandatoryPPEDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Cliente", null, true),
            new TextColumnDefinition("Trabajador", null, true),
            new TextColumnDefinition("EPI"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
        ];

        return new ActiveWorkersWoMandatoryPPEDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
